import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Analytics } from '@vercel/analytics/react';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ProgressProvider } from './context/ProgressContext';
import MainLayout from './components/MainLayout';
import Home from './pages/Home';
import DsaQuestions from './pages/DSA';
import Aptitude from './pages/Aptitude';
import Resume from './pages/Resume';
import Jobs from './pages/Jobs';
import Account from './pages/Account';
import Auth from './pages/Auth';
import { Toaster } from 'react-hot-toast';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
if (!GOOGLE_CLIENT_ID) {
  throw new Error('REACT_APP_GOOGLE_CLIENT_ID must be set in production');
}

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Home />} />
        <Route path="dsa" element={<DsaQuestions />} />
        <Route path="aptitude" element={<Aptitude />} />
        <Route path="resume" element={<Resume />} />
        <Route path="jobs" element={<Jobs />} />
        <Route path="account" element={<Account />} />
        <Route path="auth" element={!user ? <Auth /> : <Navigate to="/" />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <HelmetProvider>
        <ThemeProvider>
          <AuthProvider>
            <ProgressProvider>
              <BrowserRouter>
                <Helmet>
                  <title>PrepMaster | Your Ultimate Placement Companion</title>
                  <meta name="description" content="Master data structures, algorithms, aptitude, and land your dream job with real-time tracking." />
                </Helmet>
                <AppRoutes />
                <Toaster
                  position="bottom-right"
                  toastOptions={{
                    duration: 3000,
                    style: {
                      background: '#333',
                      color: '#fff',
                    },
                  }}
                />
                <Analytics />
              </BrowserRouter>
            </ProgressProvider>
          </AuthProvider>
        </ThemeProvider>
      </HelmetProvider>
    </GoogleOAuthProvider>
  );
}

export default App;